import { currencyInput } from '@/_schemas/generic';

import { type MarketingCampaignFormSchema, type MarketingCampaignMutationSchema } from '../schemas';

export function marketingCampaignFormToUpdate({
  campaign_type,
  total_cost_of_campaign,
  clients,
  contacts,
  attached_files,
  ...rest
}: MarketingCampaignFormSchema): MarketingCampaignMutationSchema {
  return {
    ...rest,
    campaign_type: campaign_type?.value,
    total_cost_of_campaign: currencyInput.formToUpdateConverter(total_cost_of_campaign),
    clients: clients?.map((t) => t.id) ?? [],
    contacts: contacts?.map((t) => t.id) ?? [],
    attached_files: attached_files?.map((t) => t.id) ?? [],
  };
}
